.ux-data-ingest {
  display: block;
}
